import { toast } from '@/lib/toast'

// Window-level handlers for unhandled rejections and uncaught errors: log and
// toast each so none fails silently.

// True once handlers are installed; a second setup call is a no-op.
let installed = false

// Display string for a thrown/rejected value of any type.
function messageOf(reason: unknown): string {
  if (reason instanceof Error) return reason.message
  if (typeof reason === 'string') return reason
  try {
    return JSON.stringify(reason)
  } catch {
    return String(reason)
  }
}

// Logs an error under a source tag, with optional extra context. No UI. This is
// the single sink where server-side reporting will hook in.
export function logError(reason: unknown, source: string, context?: string): void {
  if (context === undefined) console.error(`[${source}] uncaught:`, reason)
  else console.error(`[${source}] uncaught:`, reason, context)
}

function reportGlobalError(reason: unknown): void {
  logError(reason, 'global')
  // Pass the raw reason so the toast's Copy button yields the full stack.
  toast.error(`Something went wrong: ${messageOf(reason)}`, { error: reason })
}

export function setupGlobalErrorHandlers(): void {
  if (installed || typeof window === 'undefined') return
  installed = true

  window.addEventListener('unhandledrejection', (event) => {
    // Suppress the browser's own console rejection warning; handled here instead.
    event.preventDefault()
    reportGlobalError(event.reason)
  })

  window.addEventListener('error', (event) => {
    // Skip resource-load ErrorEvents (no .error); handle only uncaught exceptions.
    if (!event.error) return
    reportGlobalError(event.error)
  })
}
